import { Component } from '@mycolorway/tao';
import createPusher from 'next/javascripts/modules/pusher/create';

Component('tr-editing-presence', {
  properties: {
    channelId: String,
  },

  connected() {
    if (!this.channelId) return;
    this.pusher = createPusher();
    this.pusher.subscribe(this.channelId);
  },

  disconnected() {
    if (this.pusher) this.pusher.unsubscribe(this.channelId);
  },
});
